import { Box, Button, Stack, Typography } from '@mui/material';

import '../../assets/styles/formattedTextViewer.css';
import { gradientBackground } from '../../assets/styles/button.style';
import MessageAttachments from '../customer/report/reportDocuments/attachments/messages/MessageAttachment';

import { FileMessageAttachment } from '~/interfaces/MessagesObject';

interface DetailsProps {
  sender: string;
  date: string;
  text: string;
  files: FileMessageAttachment[];
}

const MessageDetails = ({ sender, date, text, files }: DetailsProps) => {
  const VIDEOSTARTMESSAGE = 'The case manager hosted a video meeting. To join the video meeting: ';
  // Check if the message starts with the specified string
  const isVideoMeetingMessage = text.startsWith(VIDEOSTARTMESSAGE);

  // If it starts with the specified string, extract the rest of the message
  const restOfMessage = isVideoMeetingMessage ? text.slice(VIDEOSTARTMESSAGE.length) : '';
  return (
    <Box sx={{ mt: 2, mb: 2.25 }}>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk',
          fontSize: '1rem',
          fontWeight: 500,
          lineHeight: '1.188rem',
          mt: 2.5,
        }}
      >
        {sender}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk',
          fontSize: '0.875rem',
          fontWeight: 400,
          lineHeight: '1.063rem',
          mb: 1.75,
          color: '#000000B2',
        }}
      >
        {date}
      </Typography>
      {isVideoMeetingMessage ?
        <Stack direction='row' justifyContent='space-between' alignItems='center' paddingRight='20px'>
          <span>
            {VIDEOSTARTMESSAGE}
            <a href={`${restOfMessage}`} target="_blank" rel="noopener noreferrer">
              {restOfMessage}
            </a>
          </span>
          <Button 
            component='a'
            target="_blank"
            href={`${restOfMessage}`}
            sx={{
              ...gradientBackground,
              width: '60px',
              fontSize: '14px',
              height: '',
            }}>
              Join
          </Button>
        </Stack>
        :
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          className='formatted-text-viewer'
        />
      }
      <MessageAttachments attachments = {files} isWhistleblower/>
    </Box>
  );
};

export default MessageDetails;
